import React from 'react';
import PropTypes from 'prop-types';
import { StyledSectionIntro, Header, Subheader } from './styles.js';

export const SectionIntro = ({
  headline = null,
  subheadline,
  maxWidth = null,
  typography = 'heading2',
  fontColor,
  headingLevel = 'h2',
}) => {
  return (
    <StyledSectionIntro maxWidth={maxWidth} $fontColor={fontColor}>
      {headline && (
        <Header $typography={typography} as={headingLevel}>
          {headline}
        </Header>
      )}
      {subheadline && (
        <Subheader $fontColor={fontColor}>{subheadline}</Subheader>
      )}
    </StyledSectionIntro>
  );
};
SectionIntro.displayName = 'SectionIntro';

SectionIntro.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.node,
  maxWidth: PropTypes.number,
  fontColor: PropTypes.string,
  headingLevel: PropTypes.string,
  typography: PropTypes.string,
};
